import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { useJobsNwtTracking } from '@xing-com/crate-jobs-tracking';
import {
  SingleSizeIllustrationFeedbackActiveSad,
  SingleSizeIllustrationFeedbackActiveNeutral,
  SingleSizeIllustrationFeedbackActiveVeryHappy,
} from '@xing-com/illustrations';

import { ColorFeedback } from './color-feedback';
import type { FeedbackVariant } from './color-feedback';

type Props = {
  trackingToken?: string;
  onClick: (feedback: FeedbackVariant) => void;
};

export const FeedbackContent: React.FC<Props> = ({
  trackingToken,
  onClick,
}) => {
  const { formatMessage } = useIntl();
  const trackNwtEvent = useJobsNwtTracking();

  const handleOnClick = (feedback: FeedbackVariant): void => {
    trackNwtEvent({
      eventSchema: 'aicomponent',
      page: 'jobs_search/serp',
      event: 'feedback_sent',
      feedback,
      feedbackQuestion: formatMessage({
        id: 'JOBS_SEARCH_AI_FEEDBACK_HEADLINE_V2',
      })
        .toLowerCase()
        .replace(/ /g, '_'),
      element: 'icon',
      componentName: 'ai_search',
      componentFeedbackLevel: '2',
      trackingToken,
    });

    onClick(feedback);
  };

  return (
    <IconsContainer>
      <ColorFeedback
        Illustration={SingleSizeIllustrationFeedbackActiveSad}
        variant="dislike"
        onClick={handleOnClick}
      />
      <ColorFeedback
        Illustration={SingleSizeIllustrationFeedbackActiveNeutral}
        variant="neutral"
        onClick={handleOnClick}
      />
      <ColorFeedback
        Illustration={SingleSizeIllustrationFeedbackActiveVeryHappy}
        variant="like"
        onClick={handleOnClick}
      />
    </IconsContainer>
  );
};

const IconsContainer = styled.div`
  display: flex;
  justify-content: space-evenly;
  width: 100%;
`;
